import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import { copyToClipboard as _copyToClipboard } from '@/utils/vuex';
export default {
  name: 'CoreDtwinShareButtonDialogue',
  components: {
    codemirror: codemirror
  },
  props: {
    twinId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    var _this = this;

    return {
      canShareTwin: false,
      showSharingDialog: false,
      isLoadingShareKeyRequest: false,
      existingSharingKey: null,
      urlParams: {
        markerStyleSelect: {
          value: 'default',
          text: 'Default'
        },
        markerStyleItems: [{
          value: 'default',
          text: 'Default'
        }, {
          value: 'outlined',
          text: 'Outlined'
        }],
        hidebarSwitch: false,
        indoorSwitch: false,
        pitch: 50,
        bearing: 0,
        clusterdistance: 50,
        zoomlock: false
      },
      positiveNumberRule: function positiveNumberRule(val) {
        return val < 0 ? _this.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.ruleError') : true;
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['snackbar', 'inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    n1Protocol: function n1Protocol() {
      return process.env.VUE_APP_MAIN_UI_PROTOCOL;
    },
    n1Host: function n1Host() {
      return process.env.VUE_APP_MAIN_UI_HOST;
    },
    cmOptions: function cmOptions() {
      return {
        tabSize: 4,
        mode: {
          name: 'text/html',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: true,
        readOnly: true
      };
    },
    dashboardLink: function dashboardLink() {
      return "".concat(this.n1Protocol, "://").concat(this.n1Host, "/#/public/").concat(this.existingSharingKey, "/tiles/").concat(this.twinId);
    },
    dashboardIframeCode: function dashboardIframeCode() {
      return "<iframe src=\"".concat(this.dashboardLink, "\" width=\"800\" height=\"300\"></iframe>");
    },
    mapLink: function mapLink() {
      var hidebar = this.urlParams.hidebarSwitch ? 'hidebar=true&' : 'hidebar=false&';
      var zoomlock = this.urlParams.zoomlock ? '&zoomlock=true' : '&zoomlock=false';
      var clusterdistance = parseInt(this.urlParams.clusterdistance) === 50 ? '' : "&clusterdistance=".concat(this.urlParams.clusterdistance);
      return "".concat(this.n1Protocol, "://").concat(this.n1Host, "/#/public/").concat(this.existingSharingKey, "/map/").concat(this.twinId, "?").concat(hidebar, "markerstyle=").concat(this.urlParams.markerStyleSelect.value || this.urlParams.markerStyleSelect, "&indoor=").concat(this.urlParams.indoorSwitch, "&pitch=").concat(this.urlParams.pitch, "&bearing=").concat(this.urlParams.bearing).concat(clusterdistance).concat(zoomlock);
    },
    mapIframeCode: function mapIframeCode() {
      return "<iframe src=\"".concat(this.mapLink, "\" width=\"800\" height=\"300\"></iframe>");
    }
  }),
  watch: {
    showSharingDialog: function showSharingDialog() {
      if (this.showSharingDialog) {
        this.findSharingKey();
      }
    },
    twinId: function twinId() {
      this.requestSharingStatus();
    }
  },
  mounted: function mounted() {
    this.requestSharingStatus();
  },
  methods: {
    requestSharingStatus: function requestSharingStatus() {
      var _this2 = this;

      ApiService.digitalTwinCanShare(this, this.twinId).then(function (res) {
        _this2.canShareTwin = res.canShare;
      }).catch(function (error) {
        console.error(error);
      });
    },
    findSharingKey: function findSharingKey() {
      var _this3 = this;

      this.isLoadingShareKeyRequest = true;
      ApiService.digitalTwinFindExistingShareKey(this, this.twinId).then(function (res) {
        _this3.existingSharingKey = res;
      }).catch(function (error) {
        console.error(error);
      }).finally(function () {
        _this3.isLoadingShareKeyRequest = false;
      });
    },
    shareTwin: function shareTwin() {
      var _this4 = this;

      this.isLoadingShareKeyRequest = true;
      ApiService.digitalTwinCreateShareKey(this, this.twinId).then(function (res) {
        _this4.existingSharingKey = res;
      }).catch(function (error) {
        console.error(error);
      }).finally(function () {
        _this4.isLoadingShareKeyRequest = false;
      });
    },
    unshareTwin: function unshareTwin() {
      var _this5 = this;

      this.isLoadingShareKeyRequest = true;
      ApiService.digitalTwinDeleteShareKey(this, this.twinId).then(function () {
        _this5.existingSharingKey = null;
      }).catch(function (error) {
        console.error(error);
      }).finally(function () {
        _this5.isLoadingShareKeyRequest = false;
      });
    },
    refreshForm: function refreshForm() {
      var _this6 = this;

      setTimeout(function () {
        // required workaround to get the cursor appearing at the right spot
        // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
        _this6.$refs.codemirror.codemirror.refresh();

        _this6.$refs.codemirror.codemirror.focus();
      }, 50);
    },
    onCmFocus: function onCmFocus() {
      this.refreshForm();
    },
    copyToClipboard: function copyToClipboard(event, copyValue) {
      event.stopPropagation();

      _copyToClipboard(copyValue);
    }
  }
};